
export const getCurrentTheme = (state) => {
    return state.theme;
};